import {
  MyWithdrawalChangedSubscription,
  MyWithdrawalChangedSubscriptionDocument,
} from './MyWithdrawalChangedSubscription.generated';

const onMyWithdrawalChanged: WorkerSubscription = (args) => {
  const { client, addToQueue } = args;
  client
    .request({
      query: MyWithdrawalChangedSubscriptionDocument,
      variables: { input: { isModal: false } },
    })
    .subscribe({
      error: console.error,
      next: (value) => {
        const data = value.data as Maybe<MyWithdrawalChangedSubscription>;
        const node = data?.bankingMyWithdrawChanged?.changedTransaction;
        if (node) {
          addToQueue({
            data: { ...node, operation: 'withdrawal' },
            priority: 'high',
            type: 'cashier',
          });
        }
      },
    });
};

export default onMyWithdrawalChanged;
